import { createPlatePlugin } from '@udecode/plate/react';

export const ATTACHMENT_HEADING_KEY = 'h-attachment';

export const AttachmentHeadingPlugin = createPlatePlugin({
    key: ATTACHMENT_HEADING_KEY,
    node: { isElement: true },
});
